import React from 'react'
import CrudDinamicoDefinicaoFormPageContainer from './CrudDinamicoDefinicaoFormPageContainer'

export class CrudDinamicoDefinicaoFormPage extends React.Component {
  render() {
    return <CrudDinamicoDefinicaoFormPageContainer {...this.props} />
  }
}
